import React, { Component } from 'react'
import { connect } from 'react-redux'

// Components
import Line from '../Line'
import AssesmentDBSLine from '../AssesmentDBSLine'
import RPReportFiles from './../RPReportFiles'
import AssessmentReportSums from '../AssessmentReportSums'

// Constants
import { FILE_STORAGE_API, AssessmentReporType } from '../../../../constants'
import { setCarActiveState } from '../../../../actions/car'

// Elements
import Button from '../../../elements/button'

// Utils
import { renderFullDate } from '../../../../utils/time'
import { hasAccess, hasSubscriptionPermission, hasPartnerSubscriptionPermission } from '../../../../utils/auth'
import { translation } from '../../../../utils/helpers'

import './assessmentdbs.scss'

const LineType = {
  Generic: 0,
  Work: 1,
  AdditionalWork: 2,
  Material: 3,
  StartTime: 4,
  Addition: 5,
  Deduction: 6,
  Environment: 7
}

const REPORTYPE = {
  Unknown: 0,
  Forsi: 1,
  ForsiManual: 2,
  DBS: 3
}

const DEPARTMENTTYPE = {
  Paint: 0,
  Body: 1
}
class AssessmentDBS extends Component {
  constructor (props) {
    super(props)
    this.state = {
      order: null,
      department: {},
      isPaint: false,
      isBody: false,
      attachment: null
    }
  }

  componentDidMount () {
    if (this.props.onRef) this.props.onRef(this)
    this.getDepartment()

    const isEvaluation = this.props.orderPrice !== undefined && this.props.orderPrice.IsEvaluation && this.props.router !== undefined && this.props.router.params !== undefined && this.props.router.params.addon === '3'
    const isAfterEvaluation = this.props.orderPrice !== undefined && this.props.orderPrice.IsAfterEvaluation
    let hasReport = this.props.order && this.props.order.Report && this.props.order.Report.ReportType === AssessmentReporType.DBS
    if (hasReport && !this.props.orderPrice.IsAddonPrice && !isEvaluation && !isAfterEvaluation) {
      this.props.setCarActiveState(false)
    }
  }

  componentWillUnmount () {
    if (this.props.onRef) this.props.onRef(undefined)
  }

  componentWillReceiveProps (next) {
    if (typeof next.order !== 'object') return
    this.setState({
      order: next.order
    })
    this.getDepartment()
  }

  getTitleAria () {
    // if (this.props.orderPrice === null) return null
    if (this.props.orderPrice !== null && this.props.orderPrice.IsAddonPrice) {
      return translation(34) + ' ' + translation(1396)
    }
    return translation(2705)
  }

  getEditUrl () {
    if (this.props.order.Report.ReportType === REPORTYPE.DBS && !this.props.order.Report.IsApproved) {
      if (this.props.department === DEPARTMENTTYPE.Paint && this.props.auth.departmentType === DEPARTMENTTYPE.Paint) {
        if (this.props.order !== null && this.props.order.IsAssessmentOk === true) return null

        return '/pricecalculation/' + this.props.order.Id + '/1'
      }
      if (this.props.department === DEPARTMENTTYPE.Body) {
        return '/pricecalculation/' + this.props.order.Id + '/manualbody'
      }
    }
    return null
  }

  getTitle () {
    return translation(70)
  }

  getIcon () {
    return '/images/svgs/workscreen/Insurance-black.svg'
  }

  getDepartment () {
    let report = this.props.order.Report
    let attachment = this.props.order.Report.Attachments.find(item => this.formatSectionType(item.SectionType) === this.props.department)
    if (this.props.department === DEPARTMENTTYPE.Paint) {
      let lines = [ ...report.Paint.Lines ]
      this.setState({
        department: {
          ...report.Paint,
          Lines: lines
        },
        isPaint: true,
        attachment
      })
    }
    if (this.props.department === DEPARTMENTTYPE.Body) {
      let Glass = report.Glass
      let Plastic = report.Plastic
      let lines = [ ...report.Body.Lines ]
      this.setState({
        department: {
          ...report.Body,
          Lines: lines,
          Glass,
          Plastic
        },
        isBody: true,
        attachment
      })
    }
  }

  renderDownloadlink () {
    var attachment = this.state.attachment
    if (!attachment) return null

    if (attachment !== null && attachment.OrderFileId !== null) {
      if (attachment.FileName === null) return null
      let newFileUrl = FILE_STORAGE_API + '/FileService/DownloadNoHeader?fileName=' + attachment.FileNameWithFolders + '&token=' + encodeURIComponent(this.props.auth.user.Token)
      let translateKey = this.state.isBody ? '936' : '14836'

      const renderText = () => {
        return (
          <div className='text downloadLink'>
            {translation(translateKey)}
            <a href={newFileUrl} title={attachment.FileName} target='_blank'><img src='/images/svgs/download.svg' alt='' className='downloadIcon' /></a>
          </div>
        )
      }

      return (
        <div className='dbsPDF'>
          <Line text={renderText} amount={renderFullDate(this.props.order.Report.CreatedDate)} noFormat />
        </div>
      )
    }
  }

  renderTotals () {
    let isPaint = this.state.isPaint
    let isBody = this.state.isBody

    let showPrices = hasAccess([6], this.props.auth.user.UserType) || this.props.showPrices || this.props.order.ShowPrices
    if (!showPrices) return null

    if (this.props.showOnlyWork) return null
    let department = this.state.department
    let currencyCode = this.props.currencyCode
/*
        <div>
          <Line boldText text={translation('393') + ':'} amount={department.TotalPrice} currencyType={translation(currencyCode)} />
        </div>

        <div><Line boldText text={translation('416') + ':'} amount={department.LaborTotalNoDeductionAndAddition} currencyType={translation(currencyCode)} /></div>
        {isBody && <div><Line boldText text={translation('13051') + ':'} amount={department.AdditionalTotal} currencyType={translation(currencyCode)} /></div>}
        {isPaint && <div><Line boldText text={translation('417') + ':'} amount={department.MaterialsTotal} currencyType={translation(currencyCode)} /></div>}
        {isBody && <div><Line boldText text={translation('637') + ':'} amount={department.SparepartsTotal} currencyType={translation(currencyCode)} /></div>}
        {isBody && department.Glass && <div><Line boldText text={translation('17981') + ':'} amount={department.Glass.TotalPrice} currencyType={translation(currencyCode)} /></div>}
        {isBody && department.Plastic && <div><Line boldText text={translation('123') + ':'} amount={department.Plastic.TotalPrice} currencyType={translation(currencyCode)} /></div>}

*/

    return (
      <div>
        {((isPaint && hasSubscriptionPermission(this.props.auth, 10)) || isBody) && <div><Line boldText text={translation('419') + ':'} amount={department.HourPrice} currencyType={translation(currencyCode)} /></div>}
        <AssessmentReportSums report={this.props.order.Report} department={this.props.department} currencyCode={this.props.currencyCode} />
      </div>
    )
  }

  formatSectionType (sectionType) {
    switch (sectionType) {
      case 1:
        return DEPARTMENTTYPE.Paint
      case 2:
        return DEPARTMENTTYPE.Body
      default:
        break
    }
  }

  renderForsiCompany () {
    if (!this.props.order.Report.InsuranceCompany) return null

    return (
      <div>
        <Line boldText text={translation('418') + ':'} amount={this.props.order.Report.InsuranceCompany} noFormat />
      </div>
    )
  }

  renderClasses (from) {
    let department = this.state.department
    let className = ''
    let dbsBody = 'dbs-body'

    if (from === 'render') {
      className = department === DEPARTMENTTYPE.Body ? dbsBody : 'price__view dbs'
      return className
    }
    className = department === DEPARTMENTTYPE.Body ? dbsBody : ''
    return className
  }

  renderAE (department) {
    if (!(this.props.order.ShowAE || this.props.showAE)) return null
    let className = this.renderClasses() + '__sum'
    return (
      <div>
        <Line isTotal amount={department.TotalWorkUnits} noFormat currencyType={translation('885')} className={className} />
      </div>
    )
  }

  renderWarning (hasDifference) {
    if (!hasDifference) return null
    let className = 'dbs_diff' + this.renderClasses('renderWarning')
    return <div className={className}>{translation('749')}</div>
  }

  renderLines (lines, lineType, boldText, boldAmount) {
    let showAE = this.props.order.ShowAE
    let showPrices = this.props.order.ShowPrices
    return (
      <div>
        {lines.filter(line => line.LineType === lineType).map((line, key) => {
          return (
            <div key={key}>
              <AssesmentDBSLine line={line} boldText={boldText} boldAmount={boldAmount} reportType={this.props.order.Report.ReportType} key={key} currencyCode={this.props.currencyCode} showPrices={showPrices} showAE={showAE} />
            </div>
          )
        })}
      </div>
    )
  }

  renderRpReports () {
    if (!hasSubscriptionPermission(this.props.auth, 10) && !hasPartnerSubscriptionPermission(this.props.auth, 10)) return null
    let renderPaint = this.props.editable || this.props.department === 0
    let renderBody = this.props.editable || this.props.department === 1
    let renderSparePart = this.props.editable
    return <RPReportFiles
      order={this.props.order}
      editable={this.props.editable}
      renderPaint={renderPaint}
      renderBody={renderBody}
      renderSparePart={renderSparePart}
      onUploadSuccess={this.props.loadOrder.bind(this, true)}
      showDates={!this.props.editable}
      />
  }

  renderDBS (section) {
    let ispaint = this.state.isPaint
    let isBody = this.state.isBody
    let isPaintPermission = (hasSubscriptionPermission(this.props.auth, 10) || hasPartnerSubscriptionPermission(this.props.auth, 10)) && ispaint

    const renderSection = (section) => {
      if (section === null) return null
      return (
        <div>
          {this.renderWarning(this.props.order.Report.CheckReportCalculation || section.CheckReportCalculation)}
          {this.renderLines(section.Lines, LineType.Generic)}
          {this.renderLines(section.Lines, LineType.Work)}
          {(section.Lines.findIndex(x => x.LineType === LineType.AdditionalWork) !== -1) && <hr />}
          {this.renderLines(section.Lines, LineType.AdditionalWork)}
          {this.renderLines(section.Lines, LineType.StartTime, true)}
          {this.renderAE(section)}
          {<br />}
        </div>
      )
    }

    const renderSimple = () => {
      return (
        <div>
          {this.renderWarning(this.props.order.Report.CheckReportCalculation || section.CheckReportCalculation)}
          {this.renderDownloadlink()}
          {(isBody || isPaintPermission) && this.renderLines(section.Lines, LineType.Work)}
          {this.props.department === DEPARTMENTTYPE.Body && (section.Lines.findIndex(x => x.LineType === LineType.AdditionalWork) !== -1) && <hr />}
          {(isBody || isPaintPermission) && this.renderLines(section.Lines, LineType.AdditionalWork)}
          {(isBody || isPaintPermission) && this.renderLines(section.Lines, LineType.StartTime, true)}
          {(isBody || isPaintPermission) && this.renderAE(section)}
          {<br />}

          {isBody && renderSection(section.Glass)}
          {isBody && renderSection(section.Plastic)}

          {isPaintPermission && this.renderLines(section.Lines, LineType.Generic, true, false)}
          {this.renderTotals()}
          {(isBody || isPaintPermission) && this.renderForsiCompany()}
          {<br />}
          {isBody && this.renderLines(section.Lines, LineType.Generic)}
        </div>
      )
    }

    return (
      <div className={this.renderClasses('render')}>
        {renderSimple()}

        { /* to be changed whith AssessmentRPReportFiles */ }
        {this.props.editable && this.renderRpReports()}
        {this.props.editable && <Button onClick={this.props.goBack} labelText={translation('956')} />}
      </div>
    )
  }

  render () {
    let department = this.state.department
    if (typeof this.props.order.Report !== 'object' || this.props.order.Report === null) return null
    if (Object.keys(department).length < 1) return null

    return this.renderDBS(department)
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    currencyCode: state.common.currencyCode
  }
}
export default connect(mapStateToProps, {
  setCarActiveState
})(AssessmentDBS)



// WEBPACK FOOTER //
// ./src/app/shared/components/Extent/AssessmentDBS/index.js